import { render, staticRenderFns } from "./InventoryCountingAddNew.vue?vue&type=template&id=282618b7&"
import script from "./InventoryCountingAddNew.vue?vue&type=script&lang=js&"
export * from "./InventoryCountingAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports